import React from "react";

type Props = {
	country_code: string;
};

const PoliciesAndPrivacy = (props: Props) => {
	return props.country_code === "CO" ? (
		<div className="safety">
			<h2>Política de tratamiento de datos personales</h2>
			<p>Política de tratamiento de datos personales ley 1581 de 2012</p>
			<h4>1. Disposiciones generales</h4>
			<p>
				Con el fin de dar cumplimiento a lo establecido en la Ley 1581 de 2012 y de su
				decreto reglamentario 1377 de 2013, EDITORA URBANA LTDA, identificada con NIT:
				800.229.663-1, con domicilio principal en la Calle 147 # 17 - 78 Piso 8; en la
				ciudad de Bogotá D.C, portal Web:{" "}
				<b>
					<a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a>
				</b>{" "}
				, número de teléfono: <b>333 033 3280</b> y correo electrónico:{" "}
				<b>protecciondatos@fincaraiz.com.co</b> y teniendo en cuenta que para el desarrollo
				de su actividad económica esta Compañía requiere información personal de los
				titulares de la información, se hace responsable del tratamiento de la base de datos
				que contiene información personal de cada uno de ellos, así mismo se encargará de
				velar por la adecuada recolección, tratamiento, conservación y la estricta
				confidencialidad de los mismos y propenderá por la protección de sus derechos.
			</p>
			<p>
				Teniendo en cuenta lo anterior, EDITORA URBANA LTDA informa a continuación los
				términos y condiciones del tratamiento y administración de los datos personales, su
				política de tratamiento, así como los procedimientos establecidos para que los
				titulares de la información puedan ejercer los derechos establecidos en las leyes de
				protección de datos personales.
			</p>
			<p>
				Actualmente la Compañía cuenta con una plataforma propia en la cual se captura y
				almacena la información suministrada personalmente por los titulares de la
				información; por lo tanto, los datos personales registrados en la respectiva base de
				datos cuya seguridad y políticas de acceso se encuentran exclusivamente a
				disposición del personal autorizado y capacitado. Además, se cuenta con
				procedimientos internos de seguridad de la información, protocolos de acceso y
				administración de la base de datos para evitar vulneración de la información
				almacenada.
			</p>
			<ul>
				<p>
					La presente Política establece los términos, condiciones y finalidades bajo las
					cuales EDITORA URBANA LTDA, realiza la recolección, almacenamiento, uso,
					circulación, supresión y tratamiento a los datos de los titulares de la
					información. Los Empleados, Clientes, Proveedores y los Visitantes al aceptar
					los Términos y Condiciones de EDITORA URBANA LTDA, conocidos en formularios y
					actualización de datos, están aceptando expresamente la siguiente Política y
					generan una autorización expresa para la utilización de sus datos conforme a lo
					aquí expuesto, el trabajador de EDITORA URBANA LTDA al momento de su vinculación
					mediante contrato laboral, acepta expresamente la presente Política y autoriza
					el tratamiento de sus datos personales, en el mismo sentido otorgan autorización
					los proveedores de bienes y servicios, al momento de la suscripción del
					respectivo contrato de prestación de servicios. Para el caso de clientes se debe
					solicitar la suscripción de la autorización expresa para el tratamiento de
					datos, en el momento que se requiera.
				</p>
				<p>
					Los presentes términos y condiciones aplican para cualquier registro de datos
					personales realizado para la vinculación a cualquier producto, servicio o
					beneficio de EDITORA URBANA LTDA, así como para la vinculación laboral o por
					prestación de servicios. Los titulares de la información registran o entregan su
					información de manera libre y voluntaria y reconocen que los han leído y los
					aceptan expresamente.
				</p>
			</ul>
			<h4>2. Definiciones</h4>
			<p>
				Para efectos de la aplicación de las reglas contenidas en la presente política y de
				acuerdo con lo establecido en el artículo 3 de la Ley 1581 de 2012 se dan a conocer
				los siguientes conceptos:
			</p>
			<ul>
				<p>
					<b>Aviso de privacidad: </b>Comunicación verbal o escrita generada por el
					Responsable, dirigida al Titular para el Tratamiento de sus datos personales,
					mediante la cual se le informa acerca de la existencia de las políticas de
					Tratamiento de información que le serán aplicables, la forma de acceder a las
					mismas y las finalidades del tratamiento que se pretende dar a los datos
					personales.
				</p>
				<p>
					<b>Dato público: </b> Es el dato que no sea semiprivado, privado o sensible. Son
					considerados datos públicos, entre otros, los datos relativos al estado civil de
					las personas, a su profesión u oficio y a su calidad de comerciante o de
					servidor público. Por su naturaleza, los datos públicos pueden estar contenidos,
					entre otros, en registros públicos, documentos públicos, gacetas y boletines
					oficiales y sentencias judiciales debidamente ejecutoriadas que no estén
					sometidas a reserva.
				</p>
				<p>
					<b>Datos sensibles: </b> Se entiende por datos sensibles aquellos que afectan la
					intimidad del Titular o cuyo uso indebido puede generar su discriminación, tales
					como aquellos que revelen el origen racial o étnico, la orientación política,
					las convicciones religiosas o filosóficas, la pertenencia a sindicatos,
					organizaciones sociales, de derechos humanos o que promueva intereses de
					cualquier partido político o que garanticen los derechos y garantías de partidos
					políticos de oposición, así como los datos relativos a la salud, a la vida
					sexual, y los datos biométricos.
				</p>
				<p>
					<b>Transferencia: </b> La transferencia de datos tiene lugar cuando el
					Responsable y/o encargado del Tratamiento de datos personales, ubicado en
					Colombia, envía la información o los datos personales a un receptor, que a su
					vez es Responsable del Tratamiento y se encuentra dentro o fuera del país.
				</p>
				<p>
					<b>Transmisión: </b> Tratamiento de datos personales que implica la comunicación
					de los mismos dentro o fuera del territorio de la República de Colombia cuando
					tenga por objeto la realización de un Tratamiento por el Encargado por cuenta
					del Responsable.
				</p>
				<p>
					<b>Autorización: </b> Consentimiento previo, expreso e informado del Titular
					para llevar a cabo el Tratamiento de datos personales.
				</p>
				<p>
					<b>Base de Datos: </b> Conjunto organizado de datos personales que sea objeto de
					Tratamiento.
				</p>
				<p>
					<b>Dato personal: </b> Cualquier información vinculada o que pueda asociarse a
					una o varias personas naturales determinadas o determinables.
				</p>
				<p>
					<b>Encargado del Tratamiento: </b> Persona natural o jurídica, pública o
					privada, que por sí misma o en asocio con otros, realice el Tratamiento de datos
					personales por cuenta del Responsable del Tratamiento.
				</p>
				<p>
					<b>Responsable del Tratamiento: </b> Persona natural o jurídica, pública o
					privada, que por sí misma o en asocio con otros, decida sobre la base de datos
					y/o el Tratamiento de los datos.
				</p>
				<p>
					<b>Titular de la información: </b> Persona natural cuyos datos personales sean
					objeto de Tratamiento; para EDITORA URBANA LTDA se entenderá como titular de la
					información los asociados y/o clientes, trabajadores y proveedores.
				</p>
				<p>
					<b>Tratamiento: </b> Cualquier operación o conjunto de operaciones sobre datos
					personales, tales como la recolección, almacenamiento, uso, circulación o
					supresión.
				</p>
			</ul>
			<h4>3. Almacenamiento de los datos personales</h4>
			<p>
				EDITORA URBANA LTDA solicitará los datos necesarios para la prestación del servicio,
				adquisición de productos y por vinculación laboral. En algunos casos, podrá
				solicitar información adicional y sensible la cual será de libre y voluntaria
				entrega por parte de los titulares de la información.
			</p>
			<p>
				Se informa a los titulares de la información, que una vez suministrados sus datos
				personales, de manera voluntaria y libre, a través de su vinculación y
				posteriormente cada vez que realicen actualización de sus datos, éstos serán
				almacenados en la base de datos pertinente de acuerdo al servicio, producto
				adquirido o vinculación laboral y por prestación de servicios. Así mismo, en su
				carpeta reposará documento físico con los datos recolectados soportados con su
				firma.
			</p>
			<p>
				Las bases de datos se encuentran alojadas en archivos físicos y en servidores de
				altas capacidades, ubicados en centros de datos con políticas de seguridad, de
				acuerdo a las normas internacionales y mejores prácticas avaladas por los organismos
				competentes. De igual manera, se establecen roles y políticas de acceso para
				funcionarios y entes de supervisión, contando con sistemas de vigilancia y seguridad
				competentes que garantizan su debida protección.
			</p>
			<h4>4. Tratamiento y finalidad de los datos solicitados</h4>
			<p>
				La información proporcionada por los titulares de la información de EDITORA URBANA
				LTDA se recolecta, se almacena, se usa y se comparte con algunas áreas de la
				Compañía y con entidades a las que se requieran transferir los datos para darle el
				tratamiento de acuerdo a los fines autorizados por el titular, esto con la intención
				de prestar de manera adecuada los servicios y/o productos ofrecidos.
			</p>
			<ul>
				<p>
					La información requerida se recolecta para las siguientes finalidades:
					<li>
						Llevar a cabo la gestión de nómina, controlar el horario de los
						trabajadores, planear y coordinar la formación de personal, realizar gestión
						del personal y del trabajo temporal, así como ajustarse a lo establecido en
						las normas nacionales sobre prestaciones sociales y prevención de riesgos
						laborales, promocionar y gestionar el empleo y liderar la promoción y
						selección de personal.
					</li>
					<li>
						Desarrollar relaciones financieras y de seguros con nuestros asociados y/o
						clientes.
					</li>
					<li>
						Evaluar la prestación del servicio mediante la aplicación de encuestas de
						opinión, realizar prospección comercial y generación de publicidad propia.
					</li>
					<li>
						Realizar segmentación de mercados para conocer las necesidades de nuestros
						clientes y prospectos, que permita fidelizar.
					</li>
					<li>
						Adelantar todo el tratamiento económico y contable en el que se involucre la
						gestión administrativa, de asociados, de cobros y pagos, de facturación y de
						proveedores.
					</li>
					<li>
						Transferirlos a terceros con quienes ejecute o pretenda ejecutar una
						actividad comercial.
					</li>
					<li>
						Para todas las actividades relacionadas con publicidad y mercadeo, ofertas,
						promociones e invitaciones a eventos y ferias presenciales o virtuales.
					</li>
					<li>Para fines de análisis, estadística, estudios históricos, entre otros.</li>
					<li>
						Los datos personales de los usuarios serán recabados por
						<b><a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a></b>, con fines de funcionamiento del mismo sitio
						www.fincaraiz.com.co, tales como: el registro y validación de usuarios;
						permitir el acceso y salida de los usuarios de sus cuentas; administrar las
						cuentas de los usuarios; facturación; permitir la consulta de la información
						alojada en www.fincaraiz.com.co; permitir pautar piezas o información
						publicitaria; permitir la reproducción y comunicación pública de información
						y obras; enviar información comercial relacionada con el portal, etc.
						Igualmente, los datos recabados por www.fincaraiz.com.co tendrá como objeto
						la vinculación entre clientes y la información que voluntariamente cada uno
						haya entregado o ingresado en las plataformas de www.fincaraiz.com.co. Los
						clientes vinculados podrán ser personas naturales o jurídicas, civiles o
						comerciales, de acuerdo a los servicios utilizados por cada cliente y que
						son ofrecidos por <b><a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a></b>.
					</li>
					<li>
						Los usuarios que consulten en el portal web, móvil y/o aplicaciones (Android
						e IOS) y registren sus datos personales, podrán recibir en su correo
						electrónico, dirección de correspondencia, o teléfono móvil actualizaciones
						o información comercial relacionada con <b><a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a></b> (provenientes
						de EDITORA URBANA LTDA., sus empresas filiales o matrices o terceros con
						quienes EDITORA URBANA LTDA. haya suscrito acuerdos de difusión comercial);
						concretamente, anuncios de productos o servicios caracterizados para cada
						cliente, promociones, activaciones, ofertas, lanzamientos, novedades y/o
						alianzas comerciales. <b><a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a></b> utiliza en el funcionamiento de
						sus sitios cookies, aplicaciones y funcionalidades de distinto tipo para
						personalizar la experiencia de los usuarios, identificando sus preferencias
						y búsquedas. En algunos casos, estas aplicaciones se descargarán
						automáticamente en los dispositivos desde los que accedan los usuarios;
						quienes tendrán la libertad de borrarlas en cualquier momento.
					</li>
					<li>
						Sumado a lo anterior, EDITORA URBANA LTDA podrá captar información adicional
						que considere necesaria para el desarrollo de su actividad económica
						conforme a lo establecido por la Supersolidaria, además constantemente
						documentará y/o actualizará la información de los titulares de la
						información, de conformidad con lo establecido por las normas relativas a la
						Administración del Riesgo de Lavado de Activos y Financiación del
						Terrorismo.
					</li>
				</p>
			</ul>
			<p>
				Antes de realizar una recolección o captura de datos la Compañía le dará a conocer a
				la persona la información requerida para el servicio o producto solicitado, si la
				persona decide suministrar esta información, estará aceptando que sus datos podrán
				ser utilizados para los fines que EDITORA URBANA LTDA le haya comunicado para la
				finalidad específica. Para hacer efectiva esta autorización, a partir de la fecha de
				actualización de esta política, EDITORA URBANA LTDA contará con la autorización de
				los titulares de la información para el tratamiento de sus datos personales, a
				continuación, EDITORA URBANA LTDA da a conocer los aspectos relacionados con la
				obtención de dicha autorización:
			</p>
			<ul>
				<p>
					<b>Autorización: </b> recolección, almacenamiento, uso, circulación o supresión
					de datos personales por parte de EDITORA URBANA LTDA requieren del
					consentimiento libre, del titular de los mismos. Por lo cual EDITORA URBANA LTDA
					en su condición de responsable del tratamiento de datos personales, ha dispuesto
					de los mecanismos necesarios para obtener la autorización de los titulares
					garantizando en todo caso que sea posible verificar el otorgamiento de dicha
					autorización.
				</p>
				<p>
					<b>Forma y mecanismos para otorgar la autorización:</b> EDITORA URBANA LTDA
					definirá los medios por los cuales obtendrá la autorización a saber: documento
					físico, electrónico o en cualquier otro formato que permita garantizar su
					posterior consulta. Esta autorización será puesta a disposición del titular
					previo al tratamiento de sus datos personales, de conformidad con lo que
					establece la Ley 1581 de 2012.
				</p>
				<p>
					Al obtener la autorización del titular de la información se garantiza que se le
					ha dado a conocer, los fines para los cuales ha sido recolectada su información
					personal, además que tiene la opción de conocer cualquier alteración y/o el uso
					que se le dará a los mismos.En la autorización, se informa al titular de la
					información, que EDITORA URBANA LTDA, es el responsable de recopilar sus datos
					personales, el destino de éstos y como ejercer derechos de acceso, corrección,
					actualización o supresión de los datos personales suministrados. Además se
					informa si recopilará datos sensibles.
				</p>
				<p>
					<b>Soporte de la autorización: </b>EDITORA URBANA LTDA adoptará las medidas
					necesarias para mantener registros de las autorizaciones para el tratamiento de
					datos personales por parte de los titulares de la información.
				</p>
			</ul>
			<p>
				EDITORA URBANA LTDA pondrá a disposición de los titulares de la información, la
				política de privacidad y de tratamiento de datos personales en la página web de la
				Compañía <b><a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a></b>.
			</p>
			<p>
				Los derechos de los niños, niñas y adolescentes se ejercerán por las personas que
				estén facultadas para representarlos, y bajo las condiciones que indica la ley.
			</p>
			<h4>5. Derechos de los titulares de la información</h4>
			<p>
				De conformidad con lo dispuesto en el artículo 8 de la Ley 1581 de 2012, el titular
				de la información tiene los siguientes derechos:
			</p>
			<ol>
				<li>
					Conocer, actualizar y rectificar sus datos personales frente a EDITORA URBANA
					LTDA, en su condición de Responsable y Encargados del Tratamiento; este derecho
					se podrá ejercer, entre otros frente a datos parciales, inexactos, incompletos,
					fraccionados, que induzcan a error, o aquellos cuyo tratamiento esté
					expresamente prohibido o no haya sido autorizado.
				</li>
				<li>Revocar la autorización en el momento que lo desee.</li>
				<li>
					Solicitar prueba de la autorización otorgada a EDITORA URBANA LTDA, en su
					condición de Responsable y Encargados del Tratamiento; de conformidad con lo
					previsto en el artículo 10 de la Ley 1581 de 2012.
				</li>
				<li>
					Ser informado por EDITORA URBANA LTDA, previa solicitud, respecto del uso que le
					ha dado a sus datos personales.
				</li>
				<li>
					Presentar ante la Superintendencia de Industria y Comercio quejas por
					infracciones a lo dispuesto en la Ley 1581 de 2012 y las demás normas que la
					modifiquen, adicionen o complementen.
				</li>
				<li>
					En sentencia C-748 de 2011, la Corte Constitucional declara que el Titular podrá
					ejercer su derecho de revocatoria o supresión libremente y en cualquier momento,
					sin que sea necesario un incumplimiento previo por parte del Responsable,
					siempre que el Titular no esté legal o contractualmente obligado a que sus datos
					permanezcan en poder de ese Responsable. En ese sentido, expresa la Corte “el
					individuo también es libre de decidir cuáles informaciones desea que continúen y
					cuáles deben ser excluidas de una fuente de información siempre y cuando no
					exista un mandato legal que le imponga tal deber, o cuando exista alguna
					obligación contractual entre la persona y el controlador de datos, que haga
					necesaria la permanencia del dato. Así lo establece el Artículo 9 del Decreto
					1377 de 2013, según el cual "Los Titulares podrán en todo momento solicitar al
					responsable o encargado la supresión de sus datos personales y/o revocar la
					autorización otorgada para el Tratamiento de los mismos, mediante la
					presen¬tación de un reclamo, de acuerdo con lo establecido en el artículo 15 de
					la Ley 1581 de 2012".
				</li>
				<li>
					Acceder en forma gratuita a sus datos personales que hayan sido objeto de
					Tratamiento.
				</li>
			</ol>
			<h4>6. Atención de peticiones, consultas y reclamos</h4>
			<p>
				Los titulares de la información podrán realizar las peticiones, consultas, quejas,
				reclamos, por los siguientes medios:
			</p>
			<ul>
				<p>
					<b>Personalmente: </b>Los titulares de la información podrán acercarse a las
					oficinas de EDITORA URBANA LTDA en la Calle 147 # 17 – 78 Piso 8; en la ciudad
					de Bogotá. Serán atendidos por el funcionario encargado, quien tomará nota sobre
					las peticiones, consultas, quejas, reclamos, que le expresen. De acuerdo al caso
					en gestión, podrá dar la respuesta inmediatamente, para los demás casos se
					enviará comunicación escrita con la respuesta a la petición o queja presentada.
				</p>
				<p>
					<b>Correo electrónico: </b>Se pueden comunicar mediante el correo electrónico:{" "}
					<b>protecciondatos@fincaraiz.com.co</b>. Toda solicitud, para ser tramitada,
					deberá presentarse por el titular de la información o por su representante
					legal, el cual deberá comprobar su identidad, EDITORA URBANA LTDA responderá
					todas las peticiones, consultas y reclamos de acuerdo con los términos
					establecidos por la ley.
				</p>
			</ul>
			<h4>
				7. Procedimiento de los titulares para conocer, actualizar, rectificar, suprimir
				información y revocar la autorización de información personal
			</h4>
			<p>
				Los titulares de la información de manera gratuita podrán solicitarle a EDITORA
				URBANA LTDA como responsable de los datos personales, que proporcione información
				sobre los mismos, que los actualice y los rectifique. Además podrá incluir nuevos
				datos, suprimirlos o excluirlos de la base de datos, pero en todo caso se debe
				acreditar la identidad del titular de los datos.
			</p>
			<p>
				Los derechos de rectificación, actualización o supresión únicamente se podrán
				ejercer por:
			</p>
			<ul>
				<li>
					El titular o sus causahabientes, previa verificación de su identidad, o a través
					de instrumentos electrónicos que permitan la identificación.
				</li>
				<li>
					Su representante, siempre y cuando se pueda comprobar el vínculo de la
					representación (poder autenticado por notaría).
				</li>
			</ul>
			<p>
				Cuando la solicitud sea formulada por una persona distinta al titular de los datos y
				no sea posible comprobar que la misma actúa en representación de aquél, se tomará
				por no presentada.
			</p>
			<p>
				La solicitud de rectificación, actualización o supresión debe ser presentada a
				través de los medios habilitados por EDITORA URBANA LTDA, mencionados en el numeral
				6 de la presente política y además deben contener, la siguiente información:
			</p>
			<ol>
				<li>Identificación del titular.</li>
				<li>Los documentos que acrediten su identidad.</li>
				<li>
					La dirección o medio en el que el titular quiere que se le notifique la
					respuesta
				</li>
				<li>Los documentos que se quiera hacer valer como prueba</li>
			</ol>
			<p>
				La Ley 1581 de 2012 proporciona a toda persona titular de datos personales una serie
				de garantías, que le permiten tener el poder de decisión y control sobre su
				información personal y, el derecho a la protección de la misma, por lo cual es deber
				de EDITORA URBANA LTDA cumplir con las obligaciones que le son impuestas en la ley,
				por lo tanto, da a conocer los siguientes derechos de los titulares de la
				información:
			</p>
			<p>
				<b>Derecho de acceso o conocimiento de la información: </b>El poder de disposición o
				decisión que tiene el titular de los datos sobre su información, conlleva
				necesariamente el derecho de acceder y conocer todo lo relacionado con su
				información personal, de esta manera, EDITORA URBANA LTDA garantiza al titular su
				derecho de acceso mediante las siguientes opciones:
			</p>
			<ul>
				<li>
					Si el titular de los datos lo solicita podrá tener acceso a sus datos
					personales.
				</li>
				<li>
					EDITORA URBANA LTDA le facilitará al titular de los datos, información sobre el
					tipo de datos personales tratados, todas y cada una de las finalidades que
					justifican el tratamiento. Además resolverá todas las inquietudes que éste tenga
					y facilitará soporte que solicite de la información sobre sus datos personales.
				</li>
			</ul>
			<p>
				<b>Derecho a rectificación y actualización de datos: </b>EDITORA URBANA LTDA se
				encargará de rectificar y actualizar a solicitud del titular de los datos, la
				información que resulte ser incompleta o inexacta. Al respecto se tendrá en cuenta
				lo siguiente:
			</p>
			<ul>
				<li>
					En las solicitudes de rectificación y actualización de datos que se realicen
					personalmente, el titular de los datos, debe indicar las correcciones a realizar
					y presentar la documentación que soporta su petición.
				</li>
				<li>
					EDITORA URBANA LTDA podrá habilitar mecanismos que faciliten el desarrollo de
					este derecho, siempre y cuando éstos beneficien al titular de los datos. Por lo
					cual, se podrán habilitar medios electrónicos u otros que considere pertinentes.
				</li>
				<li>
					EDITORA URBANA LTDA utilizará los servicios de atención a los titulares de la
					información mencionados en el numeral 6, sin embargo, el tiempo de respuesta
					deberá estar de acuerdo con los plazos que la ley determina.
				</li>
				<li>
					EDITORA URBANA LTDA informará a través de la página web <b><a href="https://fincaraiz.com.co">www.fincaraiz.com.co</a></b>, la
					implementación de nuevas herramientas para el desarrollo de los derechos de los
					titulares de la información o modifique las existentes.
				</li>
			</ul>
			<p>
				<b>Derecho de supresión de datos y revocatoria de la autorización: </b>Los titulares
				de la información tienen el derecho de solicitar a EDITORA URBANA LTDA la supresión
				de datos y/o revocar la autorización otorgada para el tratamiento de estos mediante
				la presentación de un reclamo de acuerdo con lo establecido en el artículo 15 de la
				ley 1581 de 2012 el cual establece lo siguiente:
			</p>
			<p>
				El Titular o sus causahabientes que consideren que la información contenida en una
				base de datos debe ser objeto de corrección, actualización o supresión, o cuando
				adviertan el presunto incumplimiento de cualquiera de los deberes contenidos en esta
				ley, podrán presentar un reclamo ante el Responsable del Tratamiento o el Encargado
				del Tratamiento el cual será tramitado bajo las siguientes reglas:
			</p>
			<ol>
				<li>
					El reclamo se formulará mediante solicitud dirigida a EDITORA URBANA LTDA como
					Responsable del Tratamiento, con la identificación del Titular, la descripción
					de los hechos que dan lugar al reclamo, la dirección, y acompañando los
					documentos que se quiera hacer valer. Si el reclamo resulta incompleto, se
					requerirá al interesado dentro de los cinco (5) días hábiles siguientes a la
					recepción del reclamo para que subsane las fallas. Transcurridos dos (2) meses
					desde la fecha del requerimiento, sin que el solicitante presente la información
					requerida, se entenderá que ha desistido del reclamo. En caso de que quien
					reciba el reclamo no sea competente para resolverlo, dará traslado a quien
					corresponda en un término máximo de dos (2) días hábiles e informará de la
					situación al interesado.
				</li>
				<li>
					Una vez recibido el reclamo completo, se incluirá en la base de datos una
					leyenda que diga "reclamo en trámite" y el motivo del mismo, en un término no
					mayor a dos (2) días hábiles. Dicha leyenda deberá mantenerse hasta que el
					reclamo sea decidido.
				</li>
				<li>
					El término máximo para atender el reclamo será de quince (15) días hábiles
					contados a partir del día siguiente a la fecha de su recibo o de la respuesta o
					aclaración del titular cuando se le requiera información necesaria para proceder
					con la reclamación. Cuando no fuere posible atender el reclamo dentro de dicho
					término, se informará al interesado los motivos de la demora y la fecha en que
					se atenderá su reclamo, la cual en ningún caso podrá superar los ocho (8) días
					hábiles siguientes al vencimiento del primer término.
				</li>
			</ol>
			<p>
				Los titulares de la información podrán solicitar la supresión de información en los
				siguientes casos:
			</p>
			<ul>
				<li>
					Cuando considere que los datos que suministró no están siendo tratados conforme
					a la Ley 1581 de 2012.
				</li>
				<li>
					Cuando los datos suministrados hayan dejado de ser necesarios para la finalidad
					para la cual fueron recolectados.
				</li>
				<li>
					Cuando la persona haya perdido su calidad de asociado de EDITORA URBANA LTDA y
					no requiera que la Compañía continúe con su información personal, la cual
					suministró cuando se vinculó a la Compañía, siempre y cuando hayan transcurrido
					10 años desde su desvinculación.
				</li>
				<li>
					Por su sola voluntad cuando los datos no sean necesarios para ejecutar la
					relación comercial que tenga el titular con EDITORA URBANA LTDA.
				</li>
			</ul>
			<p>
				Esta supresión implica la eliminación total o parcial de la información personal de
				acuerdo con lo solicitado por el titular de los datos, siempre y cuando no se
				incumpla con los requisitos requeridos en los reglamentos internos y el Estatuto de
				EDITORA URBANA LTDA.
			</p>
			<p>
				En caso de que EDITORA URBANA LTDA decida la supresión de la información ésta se
				eliminará, de tal manera que no se permita su recuperación.
			</p>
			<p>EDITORA URBANA LTDA no ejercerá el derecho a la supresión de datos cuando:</p>
			<ul>
				<li>
					El titular de la información tenga una obligación financiera en calidad de
					deudor, codeudor o tercero vigente con EDITORA URBANA LTDA.
				</li>
				<li>
					La eliminación de datos obstaculice actuaciones judiciales o administrativas.
				</li>
				<li>
					Los datos sean necesarios para proteger los intereses jurídicamente tutelados
					del titular; para realizar una acción en función del interés público, o para
					cumplir con una obligación legalmente adquirida por el titular.
				</li>
				<li>
					Cuando sean necesarios para la ejecución de las obligaciones adquiridas entre el
					titular de los datos y Editora Urbana LTDA por la naturaleza de su relación
					comercial.
				</li>
			</ul>
			<h4>
				8. Deberes de EDITORA URBANA LTDA como responsable del manejo de los datos personales
				de los titulares de la información
			</h4>
			<p>
				Los datos personales son propiedad de los titulares de esta información, por lo
				tanto, sólo ellos pueden decidir sobre los mismos, teniendo en cuenta lo anterior,
				EDITORA URBANA LTDA, hará uso de ellos sólo en aquellas finalidades para las que se
				encuentra facultado y acatando la Ley 1581 de 2012 sobre protección de datos
				personales.
			</p>
			<p>
				Teniendo en cuenta lo establecido en el artículo 17 de la Ley 1581 de 2012 EDITORA
				URBANA LTDA se compromete a cumplir en forma permanente con los siguientes deberes:
			</p>
			<ol>
				<li>
					Garantizar al Titular, en todo tiempo, el pleno y efectivo ejercicio del derecho
					de hábeas data.
				</li>
				<li>
					Solicitar y conservar, en las condiciones previstas en la presente ley, copia de
					la respectiva autorización otorgada por el Titular.
				</li>
				<li>
					Informar debidamente al Titular sobre la finalidad de la recolección y los
					derechos que le asisten por virtud de la autorización otorgada.
				</li>
				<li>
					Conservar la información bajo las condiciones de seguridad necesarias para
					impedir su adulteración, pérdida, consulta, uso o acceso no autorizado o
					fraudulento.
				</li>
				<li>
					Garantizar que la información que se suministre al Encargado del Tratamiento sea
					veraz, completa, exacta, actualizada, comprobable y comprensible.
				</li>
				<li>
					Actualizar la información, comunicando de forma oportuna al Encargado del
					Tratamiento, todas las novedades respecto de los datos que previamente le haya
					suministrado y adoptar las demás medidas necesarias para que la información
					suministrada a éste se mantenga actualizada.
				</li>
				<li>
					Rectificar la información cuando sea incorrecta y comunicar lo pertinente al
					Encargado del Tratamiento.
				</li>
				<li>
					Suministrar al Encargado del Tratamiento, según el caso, únicamente datos cuyo
					Tratamiento esté previamente autorizado de conformidad con lo previsto en la
					presente ley.
				</li>
				<li>
					Exigir al Encargado del Tratamiento en todo momento, el respeto a las
					condiciones de seguridad y privacidad de la información del Titular.
				</li>
				<li>
					Tramitar las consultas y reclamos formulados en los términos señalados en la
					presente ley.
				</li>
				<li>
					Adoptar un manual interno de políticas y procedimientos para garantizar el
					adecuado cumplimiento de la presente ley y en especial, para la atención de
					consultas y reclamos.
				</li>
				<li>
					Informar al Encargado del Tratamiento cuando determinada información se
					encuentra en discusión por parte del Titular, una vez se haya presentado la
					reclamación y no haya finalizado el trámite respectivo.
				</li>
				<li>Informar a solicitud del Titular sobre el uso dado a sus datos.</li>
				<li>
					Informar a la autoridad de protección de datos cuando se presenten violaciones a
					los códigos de seguridad y existan riesgos en la administración de la
					información de los titulares.
				</li>
				<li>
					Cumplir las instrucciones y requerimientos que imparta la Superintendencia de
					Industria y Comercio sobre el tema.
				</li>
			</ol>
			<h4>9. Transferencia de la información suministrada</h4>
			<p>
				El titular de los datos, con la aceptación de la Política de Privacidad, declara
				conocer que EDITORA URBANA LTDA, puede suministrar datos de su información personal
				a las empresas con las cuales establece vínculos comerciales para garantizar el
				mejoramiento de los servicios, y a las entidades judiciales o administrativas y
				demás entes del Estado que, en ejercicio de sus funciones, soliciten esta
				información. Igualmente acepta que podrán ser objeto de procesos de auditoría
				interna o de auditoría externa por parte de empresas encargadas de este tipo de
				control. Los datos podrán ser igualmente transferidos a título oneroso como parte de
				la actividad comercial desempeñada por Editora Urbana LTDA;
			</p>
			<h4>10. Vigencia de la autorización de tratamiento de datos personales</h4>
			<p>
				La autorización estará vigente a partir del momento en que el titular del dato la
				acepta, y durante el tiempo en que EDITORA URBANA LTDA ejerza las actividades
				propias de su actividad económica, ligada a la finalidad para la cual fue
				recolectado el dato personal y una vez termine la relación con EDITORA URBANA LTDA,
				ésta podrá conservar dicha información hasta por 10 años, sin perjuicio de la
				solicitud de eliminación de la información que pueda presentar el titular de los
				datos.
			</p>
		</div>
	) : (
		<div className="safety">
			<h2>Políticas de Privacidad</h2>
			<h4>Para Inmobiliarias</h4>
			<ul>
				<li>
					El usuario asume plena responsabilidad ante Infocasas y terceros de los posibles
					daños que ocasionen, los de sus dependientes o cualquier otro tercero que
					utilice la cuenta del usuario.
				</li>
				<li>
					El usuario es responsable por el buen uso del sitio, comprometiéndose
					expresamente a evitar cualquier tipo de acción que pueda dañar sistemas, equipos
					o servicios directa o indirectamente a través de Internet, incluyendo la
					congestión intencional de enlaces o sistemas y de acuerdo a las presentes
					condiciones.
				</li>
				<li>
					Infocasas se reserva el derecho de modificar, alterar o actualizar estos
					Términos y Condiciones de Uso en cualquier momento. Las modificaciones entrarán
					en vigencia en el momento y su aplicación es inmediata. La utilización posterior
					del sitio por el usuario significa que acepta las modificaciones efectuadas, sin
					derecho a efectuar ningún reclamo.
				</li>
				<li>
					Para registrarse los usuarios deberán completar los datos de la inmobiliaria,
					indicar una dirección de correo electrónico y una contraseña que le permitirá
					ingresar a su cuenta. El usuario se compromete a seleccionar, usar y conservar
					su contraseña de manera correcta y protegerla de terceros que puedan utilizarla
					para cualquier propósito no permitido.
				</li>
				<li>
					Los datos brindados por los usuarios del sitio se registrarán en nuestra base de
					datos, la cual se rige por lo dispuesto en la ley 18.331 y sus respectivas
					reglamentaciones.
				</li>
				<li>
					La información que contiene www.infocasas.com.uy es proporcionada por las
					inmobiliarias, por lo que Infocasas no se hace responsable de la veracidad o
					exactitud de dicha información, ni de las modificaciones realizadas. Tampoco se
					hace responsable de cualquier información que el usuario y la inmobiliaria
					intercambien por sus medios o por cualquier diferencia que surja entre ellos.
				</li>
				<li>
					Se deja aclarado expresamente que el Sitio no revisa el contenido de los
					anuncios, proveyendo única y exclusivamente un espacio para su publicación. En
					tal sentido, las inmobiliarias adheridas mantendrán indemne a Infocasas.
				</li>
				<li>
					Infocasas no se hace responsable por cualquier daño ocasionado a un usuario por
					parte de un tercero o por razones de fuerza mayor o caso fortuito.
				</li>
				<li>
					Infocasas es propietario del nombre de dominio del sitio web y de todo el
					contenido allí publicado (imágenes, logos, marcas, textos, etc.), protegido por
					las leyes referentes al derecho de autor y de marcas aplicables en la República
					Uruguay. Ningún tercero podrá utilizar el contenido con fines comerciales ni con
					fines de lucro, así como tampoco copiar la información de www.infocasas.com.uy
					para la utilización en otra página web o medio impreso con semejante o diferente
					finalidad, salvo que exista consentimiento expreso y por escrito de los
					representantes de Infocasas.
				</li>
				<li>
					En el caso que Infocasas observe y compruebe incumplimientos de los Término y
					Condiciones de Uso, se reserva el derecho a iniciar las acciones legales y
					judiciales pertinentes ante los Tribunales de Asunción, quedando pactada la
					correspondiente prórroga de competencia.
				</li>
				<li>
					Toda comunicación que deba efectuarse bajo estos Términos y Condiciones de Uso
					deberá realizarse por escrito. La comunicación con el usuario debe efectuarse a
					través de la cuenta de correo electrónico ingresada o por carta documento
					dirigida al domicilio que aparece en su ficha. Las notificaciones destinadas a
					InfoCasas deben dirigirse a la cuenta de correo electrónico
					info@infocasas.com.uy.
				</li>
				<li>
					Sobre los clientes referidos:
					<ul>
						<li>
							El plan de referidos es válido si y solo el cliente referido no contrató
							ningún producto o servicio de InfoCasas en los últimos 180 días contados
							desde la fecha de confirmación por escrito por parte del cliente
							referido, hacia atrás.
						</li>
					</ul>
				</li>
				<li>
					Sobre los créditos obtenidos por parte del cliente que refiere:
					<ul>
						<li>
							El crédito obtenido por quien refiere equivale al monto total de el o
							los productos contratados por el referido, durante el primer mes. Se
							entiende por “contratado” a una confirmación por escrito, cualquiera sea
							el medio, de la contratación de el o los productos, por parte del
							cliente referido. Se define “mes” como los 30 días corridos a partir de
							la contratación del primer producto por el referido, esto es, a la
							confirmación de la contratación por escrito a InfoCasas, del primer
							producto por parte del cliente referido. A modo de ejemplo, si el
							referido confirma por escrito un plan de suscripción, el crédito
							obtenido por quien refiere equivale al monto total del plan suscripción
							contratado por el referido. No se otorgan créditos, en el caso de que el
							cliente referido confirme que renueva, el o los productos ya contratados
							durante el primer mes, ni en meses subsiguientes.
						</li>
						<li>
							El crédito se hace efectivo una vez que el cliente referido haya abonado
							el monto total, contando impuestos, de el o los productos contratados en
							el primer mes.
						</li>
						<li>
							El crédito otorgado tiene una validez de 180 días corridos contados a
							partir de la fecha de otorgado, detallada en el punto “2.2”.
						</li>
						<li>
							Los créditos obtenidos son utilizables solo para productos ofrecidos por
							InfoCasas al precio de lista del momento de la utilización del crédito.
						</li>
						<li>
							Los créditos obtenidos no pueden ser utilizados para renovaciones de
							productos ya contratados por el cliente que refiere, debiéndose utilizar
							para nuevos productos.
						</li>
					</ul>
				</li>
			</ul>
			<h4>Para Particulares</h4>
			<ul>
				<li>
					El usuario asume plena responsabilidad ante Infocasas y terceros de los posibles
					daños que ocasione cualquier otro tercero que utilice la cuenta del usuario.
				</li>
				<li>
					El usuario es responsable por el buen uso del sitio, comprometiéndose
					expresamente a evitar cualquier tipo de acción que pueda dañar sistemas, equipos
					o servicios directa o indirectamente a través de Internet, incluyendo la
					congestión intencional de enlaces o sistemas y de acuerdo a las presentes
					condiciones.
				</li>
				<li>
					Infocasas se reserva el derecho de modificar, alterar o actualizar estos
					Términos y Condiciones de Uso en cualquier momento. Las modificaciones entrarán
					en vigencia en el momento y su aplicación es inmediata. La utilización posterior
					del sitio por el usuario significa que acepta las modificaciones efectuadas, sin
					derecho a efectuar ningún reclamo.
				</li>
				<li>
					Para registrarse los usuarios deberán completar los datos personales requeridos,
					indicar una dirección de correo electrónico y una contraseña que le permitirá
					ingresar a su cuenta. El usuario se compromete a seleccionar, usar y conservar
					su contraseña de manera correcta y protegerla de terceros que puedan utilizarla
					para cualquier propósito no permitido.
				</li>
				<li>
					Los datos brindados por los usuarios del sitio se registrarán en nuestra base de
					datos, la cual se rige por lo dispuesto en la ley 18.331 y sus respectivas
					reglamentaciones.
				</li>
				<li>
					La información que contiene Infocasas.com es proporcionada por cada usuario, por
					lo que Infocasas no se hace responsable de la veracidad o exactitud de dicha
					información, ni de las modificaciones realizadas. Tampoco se hace responsable de
					cualquier información que el usuario y los eventuales interesados intercambien
					por sus medios o por cualquier diferencia que surja entre ellos.
				</li>
				<li>
					El Usuario reconoce y acepta que la información a ser proporcionada podrá ser
					almacenada por INFOCASAS en un base de datos durante el plazo que dure la
					relación contractual con el cliente, que será utilizada por ésta a fin de
					brindar una mejor prestación del servicio.
				</li>
				<li>
					El Usuario autoriza a INFOCASAS a ser contactado por cualquier medio electrónico
					incluyendo herramientas como el mail, WhatsApp o similares a efectos de recibir
					ofertas, promociones o información general de compraventa o arrendamiento de
					inmuebles.
				</li>
				<li>
					Si cualquiera de los datos informados por el usuario a INFOCASAS fuera
					modificado, el Usuario deberá informar esa circunstancia a INFOCASAS, quien
					dispondrá de un plazo máximo de 5 días hábiles para la rectificación,
					actualización, inclusión o supresión en su base de datos.
				</li>
				<li>
					Todo titular de datos personales que previamente acredite su identificación con
					el documento de identidad o poder respectivo, tendrá derecho a obtener toda la
					información que sobre sí mismo se halle en bases de datos públicas o privadas.
					Este derecho de acceso sólo podrá ser ejercido en forma gratuita a intervalos de
					seis meses, salvo que se hubiere suscitado nuevamente un interés legítimo de
					acuerdo con el ordenamiento jurídico de acuerdo al art 14 de la Ley 18.331 y su
					Decreto reglamentario 414/09 y modificativas.El usuario tiene el derecho de
					rectificación, actualización, inclusión y modificación de sus datos personales
					todo de acuerdo con la legislación vigente.
				</li>
				<li>
					Los usuarios declaran y garantizan que: (a) toda la información proporcionada a
					INFOCASAS de conformidad con lo indicado es exacta, actualizada, completa y
					veraz; (b) en caso de ocurrir modificaciones respecto de esa información, deberá
					comunicarlo a INFOCASAS a efectos de que éste tome conocimiento de tales
					modificaciones y efectúe los ajustes necesarios en sus bases de datos, en caso
					de tenerlas.
				</li>
				<li>
					INFOCASAS reconoce que la información es estrictamente confidencial, y bajo
					ninguna circunstancia hará uso de la información confidencial que haya recibido
					y/o pudiera recibir del Usuario en beneficio propio y/o de terceros para otros
					propósitos distintos a los indicados en el presente. El deber de
					confidencialidad asumido por INFOCASAS no se extiende a aquella información que
					sea de conocimiento público, o adquiriera dominio público como consecuencia de
					la difusión hecha por terceras personas no vinculadas con INFOCASAS y/o que sea
					entregada a INFOCASAS sin obligación de reserva por terceras personas no
					vinculadas a las partes. El usuario reconoce y acepta que INFOCASAS podrá
					revelar la información confidencial en caso que cualquier autoridad pública
					competente así lo requiera, en cuyo caso no incurrirá en responsabilidad alguna
					todo de acuerdo con la Ley 18.331.
				</li>
				<li>
					El usuario a efectos de ejercer sus derechos respecto de sus datos personales se
					encuentra exento de formalidades y en forma gratuita mediante comunicación
					dirigida a INFOCASAS indicando: a Identificación del titular. b. Motivo de la
					solicitud. c. Domicilio real y domicilio constituido a efecto de las
					notificaciones. d. Fecha y firma del solicitante. e. Documentos acreditantes de
					la solicitud.
				</li>
				<li>
					Se deja aclarado expresamente que el Sitio no revisa el contenido de los
					anuncios, proveyendo única y exclusivamente un espacio para su publicación. En
					tal sentido, los usuarios mantendrán indemne a Infocasas.
				</li>
				<li>
					Infocasas no se hace responsable por cualquier daño ocasionado a un usuario por
					parte de un tercero o por razones de fuerza mayor o caso fortuito.
				</li>
				<li>
					Infocasas es propietario del nombre de dominio del sitio web y de todo el
					contenido allí publicado (imágenes, logos, marcas, textos, etc.), protegido por
					las leyes referentes al derecho de autor y de marcas aplicables en la República
					Oriental del Uruguay. Ningún tercero podrá utilizar el contenido con fines
					comerciales ni con fines de lucro, así como tampoco copiar la información de
					Infocasas.com para la utilización en otra página web o medio impreso con
					semejante o diferente finalidad, salvo que exista consentimiento expreso y por
					escrito de los representantes de Infocasas.
				</li>
				<li>
					En el caso que Infocasas observe y compruebe incumplimientos de los Términos y
					Condiciones de Uso, se reserva el derecho a iniciar las acciones legales y
					judiciales pertinentes ante los Tribunales de Montevideo, quedando pactada la
					correspondiente prórroga de competencia.
				</li>
				<li>
					Toda comunicación que deba efectuarse bajo estos Términos y Condiciones de Uso
					deberá realizarse por escrito. La comunicación con el usuario debe efectuarse a
					través de la cuenta de correo electrónico ingresada o por carta documento
					dirigida al domicilio que aparece en su ficha. Las notificaciones destinadas a
					Infocasas deben dirigirse a la cuenta de correo electrónico
					info@infocasas.com.uy.Toda comunicación que deba efectuarse bajo estos Términos
					y Condiciones de Uso deberá realizarse por escrito. La comunicación con el
					usuario debe efectuarse a través de la cuenta de correo electrónico ingresada o
					por carta documento dirigida al domicilio que aparece en su ficha. Las
					notificaciones destinadas a Infocasas deben dirigirse a la cuenta de correo
					electrónico info@infocasas.com.uy.
				</li>
			</ul>
		</div>
	);
};

export default PoliciesAndPrivacy;

